import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectModalData = (store: StoreSchema) => store.modal.data